import { StyleSheet } from 'react-native';
import theme from '../../../common/theme';
import { themeType } from '../../../common/theme-colors';

export const makeStyles = (colors: themeType) =>
  StyleSheet.create({
    container: {
      width: 600,
      alignSelf: 'center',
    },
    content: {
      padding: 30,
      marginTop: 8,
      borderRadius: theme.radius.medium,
      backgroundColor: colors.popupBg,
      ...theme.shadow.strong,
    },
    message: {
      marginBottom: 20,
    },
    list: {
      maxHeight: 400,
    },
    rows: {
      rowGap: 4,
    },
    actions: {
      marginTop: 30,
      flexDirection: 'row',
      columnGap: 10,
      justifyContent: 'flex-end',
    },
    rowDevice: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: 20,
      borderWidth: 1,
      borderRadius: theme.radius.small,
      borderColor: colors.borderColor,
      backgroundColor: colors.popupHover,
    },
    text: {
      flex: 1,
      rowGap: 4,
    },
    name: {
      fontSize: 14,
      lineHeight: 20,
      color: colors.text,
      fontFamily: theme.fonts.medium,
      fontVariant: ['tabular-nums'],
    },
    subtext: {
      fontSize: 12,
      lineHeight: 16,
      color: colors.textLight,
      fontFamily: theme.fonts.medium,
      fontVariant: ['tabular-nums'],
    },
    icon: {
      width: 20,
      height: 20,
      alignItems: 'center',
      justifyContent: 'center',
    },
  });
